import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Loading } from "matsuri-ui";
import { useRoutes } from "react-router-dom";
import { Suspense } from "react";
import { protectedRoutes } from "./protected";
import { publicRoutes } from "./public";
const routes = [...protectedRoutes, ...publicRoutes];
export const AppRoutes = () => {
    const element = useRoutes(routes);
    return _jsx(Suspense, { fallback: _jsx(Loading, {}), children: element });
};
